import { logger } from '@accedo/logger';
import { KeyCodes, KeyEventType, ValidKeys } from '@accedo/virtual-key';
import { DialogManager } from '@accedo/ctv-ui-dialog';
import { nav } from '##/services/navigation';
import { ExitDialogElement } from '##/components/Dialogs/ExitDialog';
import { logDeviceInfo } from '##/utils/deviceUtils';
import { Item } from '##/dataModels/item';

export const onKeydownGlobal = async (keyName: ValidKeys, eventType: KeyEventType): Promise<boolean> => {
  logger.info('onKeydownGlobal keyname is ', keyName, ' eventType ', eventType);
  if (keyName === KeyCodes.vKey.EXIT) {
    DialogManager.open(ExitDialogElement);
    return true;
  }

  if (keyName !== KeyCodes.vKey.INFO) {
    nav.onKeyEvent(keyName);
    return true;
  }
  if (keyName === KeyCodes.vKey.INFO && eventType === 'longPressEnd') {
    await logDeviceInfo();
    return true;
  }
  return false;
};

export const truncate = (str: string, maxLength = 10): string => {
  if (str.length <= maxLength) {
    return str;
  }
  return `${str.slice(0, maxLength - 3)}...`;
};

export const scale1080pHeight = (height: number): number =>
  Math.floor(height * (window.innerHeight / 1080));

export const getScrollOffset = (index: number, rowHeight: number, scrollStartIdx = 0): number => {
  if (index <= scrollStartIdx) {
    return -(rowHeight * index);
  }

  return -(rowHeight * (scrollStartIdx + 1));
};

const padStart = (num = 0): string => {
  if (!num) return '00';

  const strNum = num.toString();

  return `${strNum.length < 2 ? '0' : ''}${strNum}`;
};

export const addSeasonEpisodePrefixToAsset = (asset: Item): Item => {
  if (!asset) return asset;

  const { title, tvSeasonNumber, tvEpisodeNumber } = asset;

  asset.title = `S${padStart(tvSeasonNumber)}E${padStart(tvEpisodeNumber)} - ${title}`;

  return asset;
};
